import type { PublisherStatus } from './types';

export type PublisherPresentationState =
  | PublisherStatus['state']
  | 'loading'
  | 'unavailable';

export function publisherPresentationState(
  status: PublisherStatus | undefined,
  telemetryUnavailable: boolean,
): PublisherPresentationState {
  if (status) return status.state;
  return telemetryUnavailable ? 'unavailable' : 'loading';
}
